import searches from './com-search.vue'

export default searches
